import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Sunrise, Utensils, Apple, Gift, CheckCircle2 } from 'lucide-react';
export function ContentBreakdown() {
  const scrollToOffer = () => {
    const offerSection = document.getElementById('oferta');
    if (offerSection) {
      offerSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="py-16 px-4 bg-[#FDFBF7]" data-id="element-106" data-mp="1ujoczpelle01">
      <div className="max-w-lg md:max-w-4xl mx-auto" data-id="element-107" data-mp="1ukhby47bez7m">
        <div className="text-center mb-12" data-id="element-108" data-mp="1pkl9i9e9nfu6">
          <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-4" data-id="element-109" data-mp="1pjtnnqah0wh3">
            QUÉ INCLUYE NUTRIPEQUES
          </h2>
          <div className="w-24 h-1 bg-[#4CAF50] mx-auto rounded-full" data-id="element-110" data-mp="1knl1hsxuw30f"></div>
        </div>

        {/* Part 1 */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="mb-16" data-id="element-111" data-mp="1gm9g5zm0m3y1">
          <div className="flex items-center gap-3 mb-6" data-id="element-112" data-mp="495jcaqj0nce">
            <div className="bg-[#E8F5E9] p-3 rounded-xl" data-id="element-113" data-mp="4brqi99i90u3">
              <BookOpen className="w-6 h-6 text-[#2E7D32]" data-id="element-114" data-mp="99b3l5ugv7kg" />
            </div>
            <h3 className="text-2xl font-bold text-gray-900" data-id="element-115" data-mp="3rewjqtbr82cu">
              PARTE 1: Fundamentos y Herramientas
            </h3>
          </div>

          <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden" data-id="element-116" data-mp="3vfzw35ulfg9b">
            <div className="divide-y divide-gray-100" data-id="element-117" data-mp="n0ojm9t61naq">
              {[{
              title: 'La verdad sobre la alimentación infantil',
              desc: "Qué es realmente 'alimentar bien' (y qué no lo es)"
            }, {
              title: 'Principios básicos de nutrición',
              desc: 'Los 4 pilares esenciales sin tecnicismos'
            }, {
              title: 'Cómo armar un plato equilibrado',
              desc: 'Una herramienta visual, simple y repetible'
            }, {
              title: 'Cómo lograr que coman sin peleas',
              desc: 'Psicología del rechazo + estrategias que funcionan'
            }, {
              title: 'Herramientas que facilitan la rutina',
              desc: 'Sistemas reales para días reales'
            }, {
              title: 'El Sistema NutriPeques',
              desc: 'El método de planificación semanal en 30 minutos'
            }].map((item, idx) => <div key={idx} className="p-4 md:p-6 flex flex-col md:flex-row md:items-center gap-2 md:gap-6 hover:bg-gray-50 transition-colors" data-id="element-118" data-mp="11mlnj0ttm2qu" data-mpi={idx}>
                  <div className="font-bold text-gray-900 md:w-1/2" data-id="element-119" data-mp="wv3mkcrss25v">
                    {item.title}
                  </div>
                  <div className="text-gray-600 md:w-1/2" data-id="element-120" data-mp="sujptab4z0k9">{item.desc}</div>
                </div>)}
            </div>
          </div>
        </motion.div>

        {/* Part 2 */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} data-id="element-121" data-mp="iusuj6er4hj4">
          <div className="flex items-center gap-3 mb-8" data-id="element-122" data-mp="3skslznb68j1">
            <div className="bg-[#FFF3E0] p-3 rounded-xl" data-id="element-123" data-mp="8rnsl5oflok5">
              <Utensils className="w-6 h-6 text-[#E65100]" data-id="element-124" data-mp="8u9zd33i001b" />
            </div>
            <h3 className="text-2xl font-bold text-gray-900" data-id="element-125" data-mp="drtf67fugkvd">
              PARTE 2: Recetario Completo — 60 Recetas
            </h3>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-126" data-mp="3h88ts0atndcp">
            {/* Mañanas */}
            <div className="bg-[#FFF9C4]/30 rounded-3xl p-6 border border-[#FFF59D]" data-id="element-127" data-mp="3m6k6qjwey3z5">
              <div className="flex items-center gap-3 mb-4" data-id="element-128" data-mp="3r66gukgy343q">
                <Sunrise className="w-8 h-8 text-[#F57F17]" data-id="element-129" data-mp="3r4vg6tisqcgu" />
                <h4 className="text-xl font-bold text-gray-900" data-id="element-130" data-mp="3vx50nu156kbq">
                  MAÑANAS CON ENERGÍA
                </h4>
              </div>
              <p className="text-sm font-bold text-[#F57F17] mb-3" data-id="element-131" data-mp="2yh94sz3bu3jf">
                16 desayunos nutritivos y fáciles
              </p>
              <p className="text-gray-600 text-sm mb-4 italic" data-id="element-132" data-mp="19041o184oiw1">
                Desayunos sin azúcar añadida, con proteína, fibra y
                carbohidratos reales. Para que la mañana no sea un caos.
              </p>
              <ul className="space-y-2 text-sm text-gray-700" data-id="element-133" data-mp="1iqgo5yzi6m4t">
                <li data-id="element-134" data-mp="1dzgq2qendy0q">• Pancakes de banana y avena</li>
                <li data-id="element-135" data-mp="1dyouvgoyq2az">• Muffins de manzana y canela</li>
                <li data-id="element-136" data-mp="1rqlfz0s7rbxv">• Waffles de batata y avena</li>
                <li data-id="element-137" data-mp="1rpadr5ef2c8v">• Tortitas de lenteja y zanahoria</li>
                <li data-id="element-138" data-mp="1npt8abyzpf3p">• Smoothie de durazno y yogur</li>
                <li data-id="element-139" data-mp="1nrcndz8wtk3w">• Avena cremosa, pudding de chía y más</li>
              </ul>
            </div>

            {/* Platos */}
            <div className="bg-[#E8F5E9]/50 rounded-3xl p-6 border border-[#C8E6C9]" data-id="element-140" data-mp="1wpyckd8vzxdn">
              <div className="flex items-center gap-3 mb-4" data-id="element-141" data-mp="1wo5731a0fj78">
                <Utensils className="w-8 h-8 text-[#2E7D32]" data-id="element-142" data-mp="7btc9c39m9lq" />
                <h4 className="text-xl font-bold text-gray-900" data-id="element-143" data-mp="2cgmojl0eofg">
                  PLATOS QUE NUTREN
                </h4>
              </div>
              <p className="text-sm font-bold text-[#2E7D32] mb-3" data-id="element-144" data-mp="2dzsi7n9lgoig">
                22 comidas completas y equilibradas
              </p>
              <p className="text-gray-600 text-sm mb-4 italic" data-id="element-145" data-mp="249h4j903z0yd">
                Almuerzos y cenas que combinan proteína, vegetales y energía en
                formatos que los niños realmente aceptan.
              </p>
              <ul className="space-y-2 text-sm text-gray-700" data-id="element-146" data-mp="1v89gdjrb3gi0">
                <li data-id="element-147" data-mp="1vavlzdumzlxl">• Pastel de pollo y verduras cremoso</li>
                <li data-id="element-148" data-mp="208nfudeudi4f">• Ñoquis caseros de calabaza</li>
                <li data-id="element-149" data-mp="1lamps00na0i7">• Mac & Cheese versión saludable</li>
                <li data-id="element-150" data-mp="1lc64hm6nk3hv">• Nuggets de pescado al horno</li>
                <li data-id="element-151" data-mp="1q9g6007bg5m2">• Pizzetas con base de pollo o coliflor</li>
                <li data-id="element-152" data-mp="1qbsihxub1nrq">• Lasaña de verduras, wraps integrales y más</li>
              </ul>
            </div>

            {/* Snacks */}
            <div className="bg-[#FFEBEE]/50 rounded-3xl p-6 border border-[#FFCDD2]" data-id="element-153" data-mp="3kngzs6o0e2fa">
              <div className="flex items-center gap-3 mb-4" data-id="element-154" data-mp="3j6k2awvbnze5">
                <Apple className="w-8 h-8 text-[#C62828]" data-id="element-155" data-mp="3j84uifu5z68u" />
                <h4 className="text-xl font-bold text-gray-900" data-id="element-156" data-mp="3e6xkea4jtuz0">
                  SNACKS INTELIGENTES
                </h4>
              </div>
              <p className="text-sm font-bold text-[#C62828] mb-3" data-id="element-157" data-mp="398nsc8e4fahm">
                12 meriendas reales y prácticas
              </p>
              <p className="text-gray-600 text-sm mb-4 italic" data-id="element-158" data-mp="5rnmzfbltdxk">
                Para resolver viandas y meriendas sin ultraprocesados ni culpa.
              </p>
              <ul className="space-y-2 text-sm text-gray-700" data-id="element-159" data-mp="tcfvccp1hj1">
                <li data-id="element-160" data-mp="3s6ghm7vtnlwj">• Barritas de cereal caseras</li>
                <li data-id="element-161" data-mp="3s55i4k9et0b8">• Trufas energéticas de cacao y avena</li>
                <li data-id="element-162" data-mp="3o4v9t0y59xt7">• Bocaditos de lentejas</li>
                <li data-id="element-163" data-mp="oi52ujbc8f1i">• Crackers de queso</li>
                <li data-id="element-164" data-mp="oj6p7jxt0nyj">• Bastones asados con dip cremoso y más</li>
              </ul>
            </div>

            {/* Gustitos */}
            <div className="bg-[#F3E5F5]/50 rounded-3xl p-6 border border-[#E1BEE7]" data-id="element-165" data-mp="jq59xatoqmef">
              <div className="flex items-center gap-3 mb-4" data-id="element-166" data-mp="22frbmms2zxle">
                <Gift className="w-8 h-8 text-[#6A1B9A]" data-id="element-167" data-mp="27crgwvh3wwbg" />
                <h4 className="text-xl font-bold text-gray-900" data-id="element-168" data-mp="27fdp8xbtnfuq">
                  GUSTITOS CONSCIENTES
                </h4>
              </div>
              <p className="text-sm font-bold text-[#6A1B9A] mb-3" data-id="element-169" data-mp="2ge7rb37x8yfo">
                10 recetas especiales sin culpa
              </p>
              <p className="text-gray-600 text-sm mb-4 italic" data-id="element-170" data-mp="2lcizzamhd2wb">
                Porque prohibir no educa. Ofrecer mejor, sí.
              </p>
              <ul className="space-y-2 text-sm text-gray-700" data-id="element-171" data-mp="2v33x0tmi9zd4">
                <li data-id="element-172" data-mp="2v3ne684c0jq3">• Brownie de banana y cacao</li>
                <li data-id="element-173" data-mp="2z4yzw2k34kt0">• Gomitas naturales de frutas y verduras</li>
                <li data-id="element-174" data-mp="2z69zdq6hz6eb">• Paletas de banana bañadas en chocolate</li>
                <li data-id="element-175" data-mp="3453fzrh2zdip">• "Oreos" saludables sin cocción</li>
                <li data-id="element-176" data-mp="392davmn8ohdx">• Malvadiscos naturales y más</li>
              </ul>
            </div>
          </div>

          {/* Cada receta incluye */}
          <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 md:p-8" data-id="element-177" data-mp="2jxwkxyxy7vj4">
            <h4 className="text-xl font-bold text-gray-900 mb-6 text-center" data-id="element-178" data-mp="2ezlfe0eos76p">
              CADA RECETA INCLUYE:
            </h4>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-179" data-mp="2sy1qs4nhulv6">
              {[{
              icon: '⏱️',
              title: 'Tiempo',
              desc: 'Para saber antes de empezar'
            }, {
              icon: '🍽️',
              title: 'Porciones',
              desc: 'Adaptado a porciones infantiles'
            }, {
              icon: '👶',
              title: 'Edad',
              desc: 'Desde 1 año en adelante'
            }, {
              icon: '💚',
              title: 'Beneficio',
              desc: 'Simple, claro, sin tecnicismos'
            }, {
              icon: '💡',
              title: 'Tips',
              desc: 'Versiones freezer, variantes, trucos'
            }].map((item, idx) => <div key={idx} className="flex items-start gap-3 p-3 bg-gray-50 rounded-xl" data-id="element-180" data-mp="13f75we0s200l" data-mpi={idx}>
                  <span className="text-2xl" data-id="element-181" data-mp="186p8f6ig88no">{item.icon}</span>
                  <div data-id="element-182" data-mp="1889yojxqd5fq">
                    <div className="font-bold text-gray-900 text-sm" data-id="element-183" data-mp="thjbjp732uiy">
                      {item.title}
                    </div>
                    <div className="text-xs text-gray-600" data-id="element-184" data-mp="yhfdzk04udwe">{item.desc}</div>
                  </div>
                </div>)}
            </div>
          </div>
        </motion.div>

        <div className="mt-12 flex justify-center" data-id="element-185" data-mp="1r5l0ab6u4ayc">
          <button onClick={scrollToOffer} className="w-full max-w-md min-h-[64px] bg-[#2E7D32] hover:bg-[#1B5E20] text-white text-lg md:text-xl font-bold rounded-2xl shadow-[0_6px_0_#1B5E20] hover:shadow-[0_3px_0_#1B5E20] hover:translate-y-1 transition-all px-6 py-4" data-id="element-186" data-mp="1r49w4a9h916p">
            → Quiero acceder al recetario
          </button>
        </div>
      </div>
    </section>;
}